import { render, staticRenderFns } from "./orderParticulars.vue?vue&type=template&id=d266159a&scoped=true&"
import script from "./orderParticulars.vue?vue&type=script&lang=js&"
export * from "./orderParticulars.vue?vue&type=script&lang=js&"
import style0 from "./orderParticulars.vue?vue&type=style&index=0&id=d266159a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d266159a",
  null
  
)

/* custom blocks */
import block0 from "./orderParticulars.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports